export const extractReservationTableIds = (reservation: any): string[] => {
  const rawTableIds = Array.isArray(reservation?.tableIds) && reservation.tableIds.length > 0
    ? reservation.tableIds
    : Array.isArray(reservation?.mesa_ids) && reservation.mesa_ids.length > 0
      ? reservation.mesa_ids
      : (
        reservation?.tableId !== null && reservation?.tableId !== undefined
          ? [reservation.tableId]
          : (
            reservation?.mesa_id !== null && reservation?.mesa_id !== undefined
              ? [reservation.mesa_id]
              : []
          )
      );

  return [...new Set<string>(
    rawTableIds
      .map((tableId: string | number | null | undefined) => (
        tableId === null || tableId === undefined ? '' : String(tableId)
      ))
      .filter(Boolean)
  )];
};

export const getPeopleCount = (value: unknown): number | null => {
  const count = Math.floor(Number(value));
  if (!Number.isFinite(count) || count <= 0) return null;
  return count;
};

export const formatPeopleLabel = (count: number) => `${count} pessoa${count !== 1 ? 's' : ''}`;

export const extractMesaIdsFromOcupacoes = (
  ocupacoes: Array<{ mesa_id?: string | number | null } | null | undefined> = [],
): string[] => (
  [...new Set(
    (Array.isArray(ocupacoes) ? ocupacoes : [])
      .map((ocupacao) => ocupacao?.mesa_id)
      .filter((mesaId) => mesaId !== null && mesaId !== undefined)
      .map((mesaId) => String(mesaId))
  )]
);
